export * from './tip-selector';
